import focusAreaIcon from '../../../../../images/focusAreasIcon.png'
import AchievementLogo from '../../../../../images/AOlogo.png';
import RelationshipLogo from '../../../../../images/ROlogo.png';
import LeadershipLogo from '../../../../../images/LEOlogo.png';
import LearningLogo from '../../../../../images/LOlogo.png';
import NurturingLogo from '../../../../../images/NOlogo.png';

import lifeIcon from '../../../../../images/lifeIcon.png'
import involvementIcon from '../../../../../images/involvementIcon.png'
import disciplineIcon from '../../../../../images/disciplineIcon.png'


export const  buttonGroupData = [
    {
        img: focusAreaIcon,
        link: '/organisation/1/user/focus-area',
        name: "All",
        tooltip_id: 0,
        id: 0,
    },
    {
        img: AchievementLogo,
        link: '/organisation/1/user/focus-area/orientations/achievement',
        id:"achievement",
        name: "Achievement",
        tooltip_id: 1,
    },
    {
        img: RelationshipLogo,
        link: '/organisation/1/user/focus-area/orientations/relationship',
        id:"relationship",
        name: "Relationship",
        tooltip_id: 2,
    },
    {
        img: LeadershipLogo,
        link: '/organisation/1/user/focus-area/orientations/leadership',
        id:"leadership",
        name: "Leadership",
        tooltip_id: 3,
    },
    {
        img: LearningLogo,
        link: '/organisation/1/user/focus-area/orientations/learning',
        id:"learning",
        name: "Learning",
        tooltip_id: 4,
    },
    {
        img: NurturingLogo,
        link: '/organisation/1/user/focus-area/orientations/nurturing',
        id:"nurturing",
        name: "Nurturing",
        tooltip_id: 5,
    },
]

export const  buttonGroupData_all = [
    {
        img: focusAreaIcon,
        link: '/organisation/1/user/focus-area',
        name: "All",
        id: 0,
        tooltip_id: 0,
    },
    {
        img: lifeIcon,
        link: '/organisation/1/user/focus-area/all/life',
        id:"life",
        name: "Achievement",
        tooltip_id: 1,
    },
    {
        img: involvementIcon,
        link: '/organisation/1/user/focus-area/all/involvement',
        id:"involvement",
        name: "Relationship",
        tooltip_id:2
    },
    {
        img: disciplineIcon,
        link: '/organisation/1/user/focus-area/all/discipline',
        id:"discipline",
        name: "Leadership",
        tooltip_id: 3
    }
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/FocusArea/FocusAreaButtonGroupData.js